import AOS from 'aos';
import { debounce } from 'underscore'; // https://underscorejs.org
import { ScrollHandler } from './includes/scroll-handler';
import Swiper from 'swiper/bundle';
import Splide from '@splidejs/splide';

jQuery(function ($) {
    'use strict';

    // cache body selectors
    const $htmlBody = $('html, body'); // html & body selector (for menu functions)
    const $body     = $('body'); // body only selector

    // FADE IN CONTENT ON PAGE LOAD
    setTimeout(function () {
        $body.addClass('delayfade');
    }, 200);

    // homepage scroll for more btn
    if( $body.hasClass('home') ) {
        $body.find('.video-loader .scroll-more').on('click', ()=> {

            document.getElementById("header").scrollIntoView({
                behavior: "smooth" // Add smooth scrolling behavior (optional)
            });

        });
    }

    /***************************************************************/
    /********************** MENU FUNCTIONALITY *********************/
    /***************************************************************/
    // const $navDropToggle        = $('#navDropToggle'); // set mobile nav trigger
    let navState                = null;
    let navTimerClose           = null;
    const mobileBreakPoint      = 991; // make sure sass var is set the same
    const $mobileTrigger        = $('header .mobile-trigger-wrap .hamburger');
    const $dropLinks            = $('header #main-menu li.dropMenu');
    const $megaMenu             = $('header #mega-menu');
    const $mmItems              = $megaMenu.find('.mm-item');

    // check/set nav state (mobile/desktop)
    function setNavState() {

        if( $(window).width() > mobileBreakPoint ) {

            navState = 'desktop';
            $mobileTrigger.removeClass('is-active');
            $body.removeClass('sub-nav-open');
            $htmlBody.removeClass('mobile-nav-open');

        } else {

            navState = 'mobile';

        }
    }
    // store debounced version to use when window is resized (bottom of file)
    const dbc_SetNavState = debounce(setNavState, 100);


    // DESKTOP MENU FUNCTIONS
    function mmCloser() {
        if(navState == 'desktop') {

            navTimerClose = setTimeout(function() {
                $htmlBody.removeClass('megamenu-open');
                $dropLinks.removeClass('active');
                $megaMenu.css('height', 0);
            }, 200);

        }
    }

    $dropLinks.on('mouseenter', function(e) {

        if(navState == 'desktop') {
            clearTimeout(navTimerClose);

            let currSlug = $(e.currentTarget).data('drop-menu');
            $htmlBody.addClass('megamenu-open');

            if( !$(e.currentTarget).hasClass('active') ) {

                $dropLinks.removeClass('active');
                $mmItems.removeClass('active');

                $(e.currentTarget).addClass('active');
                $mmItems.filter('.'+currSlug).addClass('active');
                $megaMenu.css('height', $mmItems.filter('.'+currSlug).outerHeight());

            }
        }

    }).on('mouseleave', function(e) {

        mmCloser();

    });

    $mmItems.on('mouseenter', function(e) {

        clearTimeout(navTimerClose);

    }).on('mouseleave', function(e) {

        mmCloser();

    });
    // END DESKTOP FUNCTIONS


    // MOBILE MENU FUNCTIONS
    $mobileTrigger.on('click', function(e) {

        if(navState == 'mobile') {

            if( ! $(e.currentTarget).hasClass('is-active') ) {

                $(e.currentTarget).addClass('is-active');
                $htmlBody.addClass('mobile-nav-open');

            } else {

                $(e.currentTarget).removeClass('is-active');
                $body.removeClass('sub-nav-open');
                $htmlBody.removeClass('mobile-nav-open');

            }
        }
    });

    $dropLinks.find('a > i').on('click', function(e) {
        e.preventDefault();

        if(navState == 'mobile') {
            if( !$body.hasClass('sub-nav-open') ) {

                let currSlug = $(e.currentTarget).closest('li').data('drop-menu');

                $mmItems.removeClass('active');
                $mmItems.filter('.'+currSlug).addClass('active');

                $body.addClass('sub-nav-open');

            }
        }

    });

    $megaMenu.find('.menu-title > .back-link').on('click', function(e) {

        if(navState == 'mobile') {

            $body.removeClass('sub-nav-open');

        }

    });

    // END MOBILE MENU

    // init NavState on page load
    dbc_SetNavState();
    /********************** END MENU FUNCTIONALITY ******************/



    /***************************************************************/
    /*********************** SCROLL FUNCTIONS **********************/
    /***************************************************************/
    let homeFixedHeader     = null;
    function getHomeFixedHeaderVal() {
        if( $body.hasClass('home') && !$body.hasClass('home-sticky-header') ) {
            const headerEl      = document.querySelector('header');
            homeFixedHeader     = headerEl.getBoundingClientRect().top + window.scrollY;
        }
    }
    getHomeFixedHeaderVal();

    const headerScroll = {
        selectors: {
            body: 'body'
        },

        config: {
            fixedHeader:        100
        },

        cache: {
            $body: null
        },

        init: function() {
            this.cache.$body = $body;
            ScrollHandler.addCallback(this.onScroll, true);
        },

        onScroll: function(scrollY) {

            if( !$body.hasClass('home') ) {

                $body.toggleClass('header-fixed', scrollY >= headerScroll.config.fixedHeader);

            } else if( $body.hasClass('home') ) {

                $(window).on('resize', function() {

                    getHomeFixedHeaderVal();

                });

                if( !$body.hasClass('home-sticky-header') && scrollY >= homeFixedHeader ) {

                    $body.addClass('home-sticky-header');
                }

                if( $body.hasClass('home-sticky-header') && scrollY < homeFixedHeader ) {

                    $body.removeClass('home-sticky-header');
                }

            }
        }
    };
    headerScroll.init();
    /******************** END SCROLL FUNCTIONS *******************/



    /************************************************************************/
    /************************* FOOTER FORM ACCORDION ************************/
    /************************************************************************/
    const $footerMainContactForm = $('footer .footer-main-contact-form-wrap');
    if( $footerMainContactForm.length ) {

        const $footerFormTrigger    = $footerMainContactForm.find('.header-row .form-trigger');
        const $footerFormWrap       = $footerMainContactForm.find('.form-row > .innerwrap');

        $footerFormTrigger.on('click', (e)=> {
            e.preventDefault();

            if( !$(e.currentTarget).hasClass('form-open') ) {

                const formHeight = $footerFormWrap.outerHeight();

                $(e.currentTarget).addClass('form-open');
                $footerFormWrap.parent().css('max-height', formHeight);

            } else {

                $(e.currentTarget).removeClass('form-open');
                $footerFormWrap.parent().css('max-height', '0');

            }

        });

    }

    /*********************** END FOOTER FORM ACCORDION **********************/


    /*******************************************************************/
    /******************* PORTFOLIO - MOBILE READ MORE ******************/
    /*******************************************************************/
    if( $('body.single-portfolio .text-block-intro .text2 > .mob-trigger').length ) {

        const $mobTrigger       = $('body.single-portfolio .text-block-intro .text2 > .mob-trigger');
        const $readMoreContent  = $mobTrigger.next('.innerwrap');

        $mobTrigger.on('click', () => {
            $readMoreContent.slideToggle();
        });
    }
    /********************** END PORT. READ MORE ************************/


    /******************************************************************/
    /***************************** SLIDERS ****************************/
    /******************************************************************/
    const $hrlSlider = $('.content-slider');
    if( $hrlSlider.length ) {

        $hrlSlider.each( (_, el) => {

            // Flex Block - Basic Image Slider
            if( $(el).hasClass('slider-basic-image') ) {

                new Swiper( el.querySelector('.flexBasicImageSwiper'), {
                    loop: true,
                    rewind: true,
                    speed: 700,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                });
            }

            // Flex Block - Capabilities Slider
            if( $(el).hasClass('slider-capabilities') ) {

                let splide = new Splide( el.querySelector('.featCapabilitySplider'), {
                    type:       'loop',
                    padding:    '66px',
                    focus:      'center',
                    speed:      900,
                    pagination: false,
                    autoplay: true,
                    interval: 5000,
                    breakpoints: {
                        767: {
                            padding: 0,
                        },
                    }
                });
                let splideThumbs = new Splide( el.querySelector('.featCapabilitySplideThumbs'), {
                    loop:           true,
                    isNavigation:   true,
                    pagination:     false,
                    arrows:         false,
                    perPage:        6,
                    breakpoints: {
                        1199: {
                            perPage: 4,
                        },
                        575: {
                            perPage: 2,
                        },
                    }
                });
                let bar    = splide.root.querySelector( '.slider-progress-bar' );

                splide.on( 'mounted move', function () {
                    let end  = splide.Components.Controller.getEnd() + 1;
                    let rate = Math.min( ( splide.index + 1 ) / end, 1 );
                    bar.style.width = String( 100 * rate ) + '%';
                });
                splide.sync( splideThumbs );
                splide.mount();
                splideThumbs.mount();

            }

            // Capabilities CPT - Single Template
            if( $(el).hasClass('slider-capabilities-cpt') ) {

                new Swiper( el.querySelector('.capabilitySwiper'), {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    speed: 700,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        993: {
                            slidesPerView: 4,
                        }
                    }
                });
            }

            // Blog Single - Featured Posts
            if( $(el).hasClass('slider-featured-posts') ) {

                new Swiper( el.querySelector('.featPostsSwiper'), {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 12,
                    speed: 700,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                    }
                });
            }

            // Flex Block - Portfolio Slider
            if( $(el).hasClass('slider-portfolio') ) {

                new Swiper( el.querySelector('.featPortfolioSwiper'), {
                    loop: true,
                    speed: 700,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                });
            }

            // Team Single - Image Gallery
            if( $(el).hasClass('slider-team-gallery') ) {

                new Swiper( el.querySelector('.teamGalSwiper'), {
                    loop: true,
                    speed: 700,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                });
            }

            // Portfolio Single - Testimonial Slider
            if( $(el).hasClass('slider-testimonials') ) {

                new Swiper( el.querySelector('.testimonialSwiper'), {
                    loop: true,
                    speed: 700,
                    spaceBetween: 10,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: el.querySelector('.slide-right'),
                        prevEl: el.querySelector('.slide-left'),
                    },
                });
            }

            // Capabilities CPT - Gallery Slider with vertical thumb nav
            if( $(el).hasClass('slider-thumbs-gallery') ) {

                let galMain    = null;
                let galThumbs  = null;

                galThumbs = new Swiper( el.querySelector('.gallery-slider-thumbs'), {
                    // centeredSlides: true,
                    // centeredSlidesBounds: true,
                    slidesPerView: 4,
                    spaceBetween: 6,
                    autoHeight: true,
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    direction: 'horizontal',
                    mousewheel: true,
                    breakpoints: {
                        576: {
                            direction: 'vertical',
                            slidesPerView: 5,
                            spaceBetween: 20,
                        }
                    }
                });

                galMain = new Swiper( el.querySelector('.gallery-slider-main'), {
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    preventInteractionOnTransition: true,
                    effect: 'fade',
                        fadeEffect: {
                        crossFade: true
                    },
                    thumbs: {
                        swiper: galThumbs
                    }
                });

                galMain.on('slideChangeTransitionStart', function() {
                    galThumbs.slideTo(galMain.activeIndex);
                });

                galThumbs.on('transitionStart', function(){
                    galMain.slideTo(galThumbs.activeIndex);
                });
            }

            // Flex Block - Timeline Slider
            if( $(el).hasClass('slider-timeline') ) {

                let numYears = $(el).find('.timelineSpliderNav').data('years');

                let splide = new Splide( el.querySelector('.timelineSplider'), {
                    type:       'loop',
                    speed:      500,
                    pagination: false,
                });
                let splideNav = new Splide( el.querySelector('.timelineSpliderNav'), {
                    loop:           true,
                    isNavigation:   true,
                    pagination:     false,
                    arrows:         false,
                    perPage:        numYears,
                    focus:          'center',
                    updateOnMove:   true,
                    speed:          180,
                    breakpoints: {
                        575: {
                            perPage: 3,
                        },
                    }
                });
                let bar         = splideNav.root.querySelector('.slider-progress-bar');
                const $bartip   =  $(el).find('.slider-progress-bar > .bar-tip');

                function resizeTimeline() {
                    let containerDist = $(el).find('.timelineSpliderNav').offset().left;

                    setTimeout( () => {
                        let currDist = $(el).find('.timelineSpliderNav li.is-active span').offset().left;
                        let distance = Math.abs(containerDist - currDist);
                        let currWidth = $(el).find('.timelineSpliderNav li.is-active span').width() / 2;

                        bar.style.width = distance + 'px';
                        $bartip.css({'width' : currWidth, 'right' : "-"+currWidth+"px"});

                    }, 181);
                }

                splideNav.on( 'mounted move', function () {
                    resizeTimeline();
                });

                splide.sync( splideNav );
                splide.mount();
                splideNav.mount();

                $(window).on('resize', function() {
                    resizeTimeline();
                });

            }
        });
    }
    /*************************** END SLIDERS **************************/



    /******************************************************************/
    /********************** BLOG CATEGORY FILTERS *********************/
    /******************************************************************/
    if( $('.post-categories .mobile-filter-trigger-wrap p.trigger').length ) {

        const $filtersTrigger   = $('.post-categories .mobile-filter-trigger-wrap p.trigger');
        const $filtersWrap      = $('.post-categories .cats-col > .row-fix');

        $filtersTrigger.on('click', (e) => {
            let catsHeight = $filtersWrap.find('ul').outerHeight();

            console.log(catsHeight);

            if( !$(e.currentTarget).hasClass('open') ) {

                $(e.currentTarget).addClass('open');
                $filtersWrap.addClass('open');

            } else {

                $(e.currentTarget).removeClass('open');
                $filtersWrap.removeClass('open');

            }
        });


    }
    /******************** END BLOG CATEGORY FILTERS *******************/


    /******************************************************************/
    /************************* HELPERS / FIXES ************************/
    /******************************************************************/

    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p, .no-child-orphans a').each(function() {
        var string = $(this).html();
        string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
        $(this).html(string);
    });

    /*************************** END HELPERS ***************************/





    /***************************************************************************/
    /****************** KEEP THESE FUNCTIONS NEAR BOTTOM *****************/
    /***************************************************************************/


    // AOS (animate on scroll) INIT - https://michalsnik.github.io/aos/
    // (must call after any slick sliders to prevent conflicts)
    AOS.init({
        duration:   600,
        offset:     120,
    });

    // weird issue with aos not correctly loading at first.  refresh it slightly after load to force correct behavior
    // setTimeout( function() {
    //     AOS.refresh();
    // }, 700);


    // WINDOW RESIZER FUNCTIONS (create 'dbc_' debounced versions for use here)
    $(window).on('resize', function() {

        // check/set nav state (mobile/desktop)
        dbc_SetNavState();

        // set home fixed header val
        // if( $body.hasClass('home') ) {
        //     dbc_GetHomeFixedHeaderVal();
        // }

        AOS.refresh();

    });
});
